import { IProperty } from './IProperty.interface';

export interface IFormOptions {
    properties: IProperty[];
    submitText?: string;
    invalidText?: string;
    mandatoryText?: string;
}
